const types = {
  SET_LIST_WORD_CLOUD: 'SET_LIST_WORD_CLOUD',
  SET_TRASH_ANSWERS: 'SET_TRASH_ANSWERS',
  SET_TRASH_ACTIONS: 'SET_TRASH_ACTIONS',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/answers/mutations-types.js